<template lang="pug">
  #mental-content-all
    BLoading(:active="contentLoading" :is-full-page="true")
    .content-box(v-if="!contentLoading")
        TopicViewAll(v-if="isTopics" :contentGroupByInterest="contentGroupByInterest")
        ArticleViewAll(v-if="isArticles" :articles="articles")
        WorkshopViewAll(v-if="isWorkshops" :workshops="workshops")
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import CompanionActionsMenu from "@@/Companion/CompanionActionsMenu";
import TopicViewAll from "@@/Companion/Topics/TopicViewAll";
import ArticleViewAll from "@@/Companion/Articles/ArticleViewAll";
import WorkshopViewAll from "@@/Companion/Workshops/WorkshopViewAll";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CompanionViewAll",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    CompanionActionsMenu,
    TopicViewAll,
    ArticleViewAll,
    WorkshopViewAll
  },
  mixins: [analyticsTrackingMixin],
  data() {
    return {
      topics: [],
      articles: [],
      workshops: [],
      contentLoading: true,
      contentType: ""
    };
  },
  computed: {
    ...mapGetters("companion", ["getArticles", "getTopics", "getWorkshops"]),
    ...mapGetters("program", ["isCoreTier"]),

    isTopics() {
      return this.contentType === "topics";
    },
    isArticles() {
      return this.contentType === "articles";
    },
    isWorkshops() {
      return this.contentType === "workshops";
    },
    wheelListener() {
      if (window.innerWidth >= 768) {
        return {
          wheel: this.handleWheel
        };
      } else {
        return {};
      }
    },
    contentGroupByInterest() {
      if (this.topics.length > 0) {
        let grpByInterest = {};
        this.topics.forEach(topic => {
          if (grpByInterest[topic.Interest]) {
            grpByInterest[topic.Interest].push(topic);
          } else {
            grpByInterest[topic.Interest] = [topic];
          }
        });
        return grpByInterest;
      }
      return {};
    }
  },
  async mounted() {
    try {
      let type = this.$route.params.contentType;
      if (this.isCoreTier && type === "workshops") {
        this.$router.push({ name: "404" });
      }
      this.contentType = type;
      this.trackFeatureView("learn", `learn_${type}`);
      if (type === "topics") {
        await this.loadTopics(type);
      } else if (type === "articles") {
        await this.loadArticles(type);
      } else if (type === "workshops") {
        await this.loadWorkshops(type);
      } else {
        throw new Error("Page not found.");
      }
    } catch (e) {
      this.contentLoading = false;
      this.snackBar({
        duration: 5000,
        type: "is-danger",
        message: e.message
      });
    }
  },

  methods: {
    ...mapActions("companion", [
      "fetchTopics",
      "fetchArticles",
      "fetchUserWorkShops"
    ]),
    ...mapActions(["snackBar"]),

    async loadTopics(contentType) {
      this.contentLoading = true;
      let response = this.getTopics(contentType);
      if (
        Object.keys(response).length === 0 ||
        Object.keys(response.data).length === 0
      ) {
        response = await this.fetchTopics({
          contentType: contentType
        });
      }
      this.contentLoading = false;
      this.topics = response.data;
    },

    async loadArticles(contentType) {
      this.contentLoading = true;
      let response = this.getArticles(contentType);
      if (
        Object.keys(response).length === 0 ||
        Object.keys(response.data).length === 0
      ) {
        response = await this.fetchArticles({
          contentType: contentType
        });
      }
      this.contentLoading = false;
      this.articles = response.data.Items;
    },

    async loadWorkshops(contentType) {
      this.contentLoading = true;
      let response = this.getWorkshops(contentType);
      if (
        Object.keys(response).length === 0 ||
        Object.keys(response.data).length === 0
      ) {
        response = await this.fetchUserWorkShops();
      }
      this.contentLoading = false;
      //add daysUntilStart property to data response
      let allWorkshops = response.data;
      let futureWorkshops = [];
      let pastPresentWorkshops = [];
      allWorkshops.forEach(workshop => {
        let start = new Date(workshop.StartDate);
        let today = new Date();
        let days = this.moment(start).diff(this.moment(today), "days");
        if (start > today) {
          workshop.daysUntilStart = days;
          futureWorkshops.push(workshop);
        } else {
          pastPresentWorkshops.push(workshop);
        }
      });
      //return workshops in order from most upcoming future - past
      this.workshops = futureWorkshops
        .sort((a, b) => a.daysUntilStart - b.daysUntilStart)
        .concat(pastPresentWorkshops);
    },
    goBack() {
      window.history.back();
    }
  }
};
</script>
<style scoped>
#mental-content-all {
  width: 700px;
  margin: 0 auto;
}
.content-box {
  display: flex;
  width: 700px !important;
  flex-direction: column !important;
  gap: 24px !important;
}

@media (max-width: 767px) {
  #mental-content-all {
    width: 100% !important;
    margin: 0 auto;
  }
  .content-box {
    width: 100% !important;
  }
}
</style>
